module.exports = __webpack_public_path__ + "static/media/tempe-campus.860d914f.jxr";